import { Dashboard } from "../index";

export const Procurement = () => {
    return (
        <Dashboard />
    );
};